import { MediaResolver, ResolvedMedia, ResolverContext } from '../types';
import { extractIframeSrc, extractMetaContent, toAbsoluteUrl } from '../utils/htmlMeta';

export class GenericEmbedResolver implements MediaResolver {
  name = 'GenericEmbedResolver';

  async canResolve(context: ResolverContext): Promise<boolean> {
    try {
      const content = await context.fetchContent(context.input.url);

      if (!content.html) {
        return false;
      }

      return Boolean(
        extractMetaContent(content.html, 'property', 'og:video:iframe') ??
          extractMetaContent(content.html, 'name', 'twitter:player') ??
          extractIframeSrc(content.html)
      );
    } catch {
      return false;
    }
  }

  async resolve(context: ResolverContext): Promise<ResolvedMedia | null> {
    const content = await context.fetchContent(context.input.url);

    if (!content.html) {
      return null;
    }

    const embedUrl =
      extractMetaContent(content.html, 'property', 'og:video:iframe') ??
      extractMetaContent(content.html, 'name', 'twitter:player') ??
      extractIframeSrc(content.html);

    if (!embedUrl) {
      return null;
    }

    return {
      mediaType: 'video',
      playerType: 'iframe',
      embedUrl: toAbsoluteUrl(embedUrl, content.finalUrl),
      thumbnailUrl:
        extractMetaContent(content.html, 'property', 'og:image') ??
        context.input.thumbnailUrl ??
        undefined,
      title:
        extractMetaContent(content.html, 'property', 'og:title') ??
        context.input.title ??
        undefined,
      description: extractMetaContent(content.html, 'property', 'og:description') ?? undefined,
      resolved: true,
      resolverName: this.name,
      metadata: {
        embedType: 'iframe',
      },
    };
  }
}
